'use strict';

var _ = require('lodash');
function HolidaysAndSpecialEventsCSVService(gridExportCSVService, momentService) {
  /*
  Contains the Map of Key - Title for the CSV Header, values
   */
  var columnsHeaderMapToExport = {
    origin: 'Origin',
    destination: 'Destination',
    eventName: 'Event',
    eventType: 'Event Type',
    startDate: 'Start Date',
    endDate: 'End Date'
  };
  function allToNull(value) {
    if (value && (value.toLowerCase() === 'all' || value.toLowerCase() === 'alls')) {
      return '';
    }
    return value;
  }
  function exportToCSV(rows) {
    return _.chain(rows).map(function (row) {
      row.origin = allToNull(row.origin);
      row.destination = allToNull(row.destination);
      row.startDate = row.startDate.format(momentService.FORMAT.YEAR_MONTH_DAY_NOT_SEPARATED);
      row.endDate = row.endDate.format(momentService.FORMAT.YEAR_MONTH_DAY_NOT_SEPARATED);
      return row;
    }).thru(function (rows) {
      return gridExportCSVService.exportToCSV(rows, columnsHeaderMapToExport, 'HolidaysAndSpecialEvents.csv');
    }).value();
  }
  return {
    exportToCSV: exportToCSV
  };
}
HolidaysAndSpecialEventsCSVService.$inject = ['GridExportCSVService', 'MomentService'];
module.exports = HolidaysAndSpecialEventsCSVService;